module.exports = __webpack_public_path__ + "static/12-d8a0fec008dfea9a9374470723032909.png";